<!--*
 * List of items needed by the surveyor
 *
 * @author   pablo.barco
 * @date     2024-01-18
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
-->
<template>
  <div>
    <div class="mt-2">
      {{ $t('itemsNeeded.introduction') }}
    </div>
    <div v-if="groups.length > 0">
      <div class="row">
        <div v-for="group in groups" :key="'g'+group.id" class="col--12 col--md--6 col--lg--4">
          <div class="mt-8">
            <div class="h4 m-0">
              {{ $t(group.name) }}
            </div>
          </div>
          <div class="mt-6">
            <ul class="m-0">
              <li v-for="item in group.items" :key="'i'+item.id" class="mb-4">
                {{ $t(item.description) }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="py-11 text-center">
        <div class="h2">
          {{ $t('itemsNeeded.noItems.label') }}
        </div>
      </div>
    </div>
    <smtt-toast style="border-style: none" ref="errorToast"></smtt-toast>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  'name': 'AppItemList',
  'data': function () {
    return {
      'groups': []
    }
  },
  'methods': {
    ...mapActions([
      'getItemsYouNeed'
    ]),
    'showErrorToast': function (message) {
      const toastElement = this.$refs.errorToast;
      toastElement.error({
        'message': message != null ? this.$t(message.code, message.params) : this.$t('error.default.connection.message'),
        'header': this.$t('error.default.connection.title'),
        'duration': 5000
      });
    }
  },
  created() {
    this.getItemsYouNeed().then((response) => {
      if (response.success) {
        this.groups = response.groups
      } else {
        this.showErrorToast(response.message)
      }
    }).catch((error) => {
      this.showErrorToast(error.response.message)
    })
  }
}
</script>
